import React from 'react';
import Icon from '../app_components/Icon';
import { semantic } from '@lexody/design-tokens';
import { usesDashFormVariant } from '../../utils/formVariant';

class LexChipGroup extends React.Component {
  render() {
    const { label, hint, options, value, onChange, attribute, tone = 'grey', variant } = this.props;

    if (usesDashFormVariant(variant)) {
      return (
        <div className="lex-dash-field">
          {label && <label className="lex-dash-field__label">{label}</label>}
          {hint && <p className="lex-dash-field__hint">{hint}</p>}
          <div className="lex-dash-segmented" role="radiogroup" aria-label={label}>
            {options.map((option) => {
              const selected = option.value === value;
              return (
                <button
                  key={option.value}
                  type="button"
                  role="radio"
                  aria-checked={selected}
                  className={`lex-dash-segmented__btn${selected ? ' is-active' : ''}`}
                  onClick={() => onChange(option.value, attribute)}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      );
    }

    return (
      <div className="lex-field">
        {label && <p className="lex-field__label">{label}</p>}
        {hint && <p className="lex-field__hint">{hint}</p>}
        <div className="lex-chip-group" role="radiogroup" aria-label={label}>
          {options.map((option) => {
            const selected = option.value === value;
            const chipClass = [
              'lex-chip',
              selected ? 'lex-chip--selected' : '',
              tone === 'blue' ? 'lex-chip--blue' : '',
            ].filter(Boolean).join(' ');

            return (
              <button
                key={option.value}
                type="button"
                role="radio"
                aria-checked={selected}
                className={chipClass}
                onClick={() => onChange(option.value, attribute)}
              >
                {selected && (
                  <Icon name="check" size={14} color={semantic.primary.text.label} solid />
                )}
                {option.label}
              </button>
            );
          })}
        </div>
      </div>
    );
  }
}

export default LexChipGroup;
